import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from './utils/baseQuery'
import {
    ANSWER_CATEGORY_TAG,
    ASSIGNMENT_TAG,
    CATALOG_ITEM_TAG,
    COMPONENT_TAG,
    GROUP_TAG,
    PATTERN_TAG,
    PROBLEM_SET_TAG,
    QUESTION_TAG,
    CATEGORY_TAG,
    SHARE_SUGGESTION_TAG,
    VERSION_TAG,
} from './utils/tags'

const baseApi = createApi({
    reducerPath: 'api',
    tagTypes: [
        PROBLEM_SET_TAG,
        ASSIGNMENT_TAG,
        COMPONENT_TAG,
        GROUP_TAG,
        QUESTION_TAG,
        CATEGORY_TAG,
        CATALOG_ITEM_TAG,
        PATTERN_TAG,
        VERSION_TAG,
        SHARE_SUGGESTION_TAG,
        ANSWER_CATEGORY_TAG,
    ],
    baseQuery,
    endpoints: () => ({}),
})

export default baseApi
